import React from "react";
import downIcon from './assets/down.png';
import { FaRegFilePdf } from "react-icons/fa";
const sections = [
  {
    title: "Grundstufe",
    image: downIcon,
    downloads: [
        { label: 'Anmeldeformular', download: 'anmeldeformular.pdf', url: '/assets/igsgrundstufe/Schulvertrag_IGSGS_GS_mai25.pdf'}
    ],
  },
  {
    title: "Sekundarstufe",
    image: "",
    downloads: [
        {label: 'Anmeldeformular', download: 'anmeldeformular.pdf', url: '/assets/sekundarstufe/Schulvertrag_IGSGS_IGS_mai25.pdf'}
    ],
  },
  {
    title: "Fachoberschule",
    image: "",
    downloads: [
        {label: 'FOS Anmeldeformular', download: 'FOS Anmeldeformular.pdf', url: '/assets/fachoberschule/Schulvertrag_FOS_mai25.pdf'},
        {label: 'FOS Praktikantenvertrag', download: 'FOS Praktikantenvertrag Wirtschaft .pdf', url: '/assets/fachoberschule/FOS Praktikantenvertrag Wirtschaft .pdf'},
        {label: 'FOS Vordruck Entschuldigungsschreiben',download: 'FOS Vordruck Entschuldigungsschreiben.pdf',url: '/assets/fachoberschule/FOS Vordruck Entschuldigungsschreiben.pdf'},
        {label: 'FOS Lehrplan Wirtschaft und Verwaltung',download: 'FOS Lehrplan.pdf',url: '/assets/fachoberschule/FOS Lehrplan.pdf'}
    ],
  },
  {
    title: "Berufsfachschule",
    image: "",
    downloads: [
        {label: 'BFS Anmeldeformular', download: 'BFS Schulvertrag.pdf', url: '/assets/berufsfachschule/Schulvertrag_BFS_mai25.pdf'},
        {label: 'BFS Verordnung über die Ausbildung und die Prüfung vom 02. Dezember 2011', download: 'BFS Verordnung über die Ausbildung und die Prüfung.pdf', url: '/assets/berufsfachschule/BFS Verordnung über die Ausbildung und die Prüfung.pdf'},
        {label: 'BFS Vordruck Entschuldigungsschreiben',download: 'BFS Vordruck Entschuldigungsschreiben.pdf',url: '/assets/berufsfachschule/BFS Vordruck Entschuldigungsschreiben.pdf'},
        {label: 'BFS Lehrplan Wirtschaft ',download: 'BFS Lehrplan Wirtschaft.pdf',url: '/assets/berufsfachschule/BFS Lehrplan Wirtschaft.pdf'}
                               ],
  },
  {
    title: "Höhere Berufsfachschule",
    image: "",
    downloads: [
         {label: 'BFS Anmeldeformular', download: 'BFS Schulvertrag.pdf', url: '/assets/höhereberufsfachschule/Schulvertrag_BFS_mai25.pdf'},
         {label: 'H-BFS Verordnung über die Ausbildung und die Prüfung vom 02. Dezember 2011', download: 'BFS Verordnung über die Ausbildung und die Prüfung.pdf', url: '/assets/höhereberufsfachschule/BFS Verordnung über die Ausbildung und die Prüfung.pdf'},
         {label: 'BFS Vordruck Entschuldigungsschreiben',download: 'BFS Vordruck Entschuldigungsschreiben.pdf',url: '/assets/höhereberufsfachschule/BFS Vordruck Entschuldigungsschreiben.pdf'},
         {label: 'BFS Lehrplan Wirtschaft',download: 'BFS Lehrplan Wirtschaft.pdf',url: '/assets/höhereberufsfachschule/BFS Lehrplan Wirtschaft.pdf'}

    ],
  },
];

const gradients = [
    'linear-gradient(90deg, #ffe433, #ffb700)',      // sarıdan kırmızıya
    'linear-gradient(90deg, #ff9100, #ff6000)',      // sarıdan kırmızıya
    'linear-gradient(90deg, #42a5f5, #0077b6)',      // mavi tonlar
    'linear-gradient(90deg, #4ad66d, #047857)',      // yeşilden koyu yeşile
    'linear-gradient(90deg, #ef3c2d, #a50104)',      // kirmizi tonlar





];

const DownloadsPage = () => {
  return (
    <div className="wrapper">
      <section className="wrapperContent">
        <div className="max-w-6xl mx-auto  py-8">
          {sections.map((section, index) => (
            <div key={section.title} className="w-full">
              <h2
                className={`text-3xl sm:text-5xl font-bold px-5 sm:px-6 py-3 rounded-md text-white ${index !== 0 ? 'mt-8' : ''}`}
                style={{
                  background: gradients[index % gradients.length],
                  display: 'flex',
                  alignItems: 'center',
                  height: '104px',
                }}
              >
                {section.title}
              </h2>

              <ul className="space-y-4 list-none p-0 m-0">
                {section.downloads.map((file, idx) => (
                  <li key={idx}>
                    <a
                      href={file.url}
                      className="flex items-center gap-3 no-underline text-black hover:text-blue-800 transition-colors duration-200"
                      download={file.download}
                      style={{ color: 'black', minHeight: '40px', alignItems: 'center' }}
                    >
                      <div style={{ flexShrink: 0, width: '26px', height: '26px' }}>
                        <FaRegFilePdf style={{ color: '#C0373D' }} size={26} />
                      </div>
                      <span>{file.label}</span>
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </section>
    </div>
  );


};

export default DownloadsPage;
